import React, { useEffect } from 'react';
import { Routes, Route, useLocation, Navigate } from 'react-router-dom';

import LoginPage from './components/Login';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import { useAuth } from './AuthContext';
import ScrapperPage from './components/ScrapperPage';

function PrivateRoute({ children }) {
  const { user } = useAuth();
  return user ? children : <Navigate to="/" replace />;
}

function App() {
  const location = useLocation();
  const { setUser } = useAuth();
  const isLoginPage = location.pathname === '/';

  useEffect(() => {
    if (isLoginPage) {
      // Clear auth data
      setUser(null);
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      // Disable back button
      window.history.pushState(null, '', window.location.href);
      const handlePopState = (e) => {
        if (window.location.pathname === '/') {
          window.history.pushState(null, '', window.location.href);
        }
      };
      window.addEventListener('popstate', handlePopState);
      return () => window.removeEventListener('popstate', handlePopState);
    }
  }, [isLoginPage, setUser]);

  return (
    <>
    <div className='app-container' >
    <div className='header'>
      {<Navbar />}
      </div>
      <div className="main-content"> 
        <Routes>
          <Route path="/" element={<LoginPage />} />
          <Route path="/scrapper" element={<PrivateRoute><ScrapperPage /></PrivateRoute>} />
          <Route path="*" element={<h2>404 - Page Not Found</h2>} />
        </Routes>
      </div>
      <div className='footer'>
      {<Footer />}
      </div>
      </div>
    </>
  );
}

export default App;
